module.exports = {"623026100":"郎木寺镇","623026101":"玛艾镇","623026102":"西仓镇","623026103":"尕海镇","623026104":"双岔镇","623026202":"拉仁关乡","623026204":"阿拉乡","623026402":"双岔林场","623026403":"李恰如种畜场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/623026.json
// module id = 2977
// module chunks = 0